import { render, staticRenderFns } from "./ExpiredCertifie.vue?vue&type=template&id=3d8f5236&"
import script from "./ExpiredCertifie.vue?vue&type=script&lang=js&"
export * from "./ExpiredCertifie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports